import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
    selector: 'app-bin-management',
    templateUrl: './bin-management.component.html',
    styleUrls: ['./bin-management.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class BinManagementComponent implements OnInit {

  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data, private _bottomSheetRef: MatBottomSheetRef<BinManagementComponent>) { }

  ngOnInit() {
    console.log(this.data,'data')
  }

  closeBottomSheet(event: MouseEvent) {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

}
